/** The RoadricsAI mark: a road in perspective with its centre line. Colours come from tokens.css. */
export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="7" fill="var(--brand-blue)" />
      <path d="M11 27 15 5h2l4 22" fill="none" stroke="var(--on-dark)" strokeWidth="2.4" strokeLinejoin="round" />
      <path d="M16 9v3m0 4v3m0 4v3" stroke="var(--signal)" strokeWidth="1.8" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return <span className={`brand-name${className ? ` ${className}` : ""}`}>Roadrics<b>AI</b></span>;
}
